interface SkeletonLoaderProps {
  className?: string;
  variant?: 'text' | 'card' | 'metric' | 'circle';
}

export function SkeletonLoader({ className = '', variant = 'text' }: SkeletonLoaderProps) {
  const baseClasses = 'animate-pulse bg-gray-800';
  
  const variantClasses = {
    text: 'h-4 rounded',
    card: 'h-32 rounded-xl',
    metric: 'h-12 rounded-lg',
    circle: 'rounded-full',
  };

  return (
    <div className={`${baseClasses} ${variantClasses[variant]} ${className}`} />
  );
}

// Preset skeleton patterns
export function MetricCardSkeleton() {
  return (
    <div className="bg-sg-card border border-sg-border rounded-xl p-6">
      <SkeletonLoader className="w-24 mb-3" variant="text" />
      <SkeletonLoader className="w-16 h-8" variant="metric" />
    </div>
  );
}

export function ThreatCardSkeleton() {
  return (
    <div className="bg-gray-900 border border-gray-800 rounded-lg p-4">
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1 space-y-2">
          <div className="flex items-center gap-3">
            <SkeletonLoader className="w-20 h-6" variant="text" />
            <SkeletonLoader className="w-16 h-6" variant="text" />
          </div>
          <SkeletonLoader className="w-32 h-4" variant="text" />
        </div>
      </div>
      <div className="space-y-2">
        <SkeletonLoader className="w-full h-16" variant="card" />
        <SkeletonLoader className="w-3/4 h-16" variant="card" />
      </div>
    </div>
  );
}

export function TableRowSkeleton() {
  return (
    <tr className="border-b border-sg-border">
      <td className="p-4">
        <SkeletonLoader className="w-20 h-6" variant="text" />
      </td>
      <td className="p-4">
        <SkeletonLoader className="w-32 h-4" variant="text" />
      </td>
      <td className="p-4">
        <SkeletonLoader className="w-full h-12" variant="text" />
      </td>
      <td className="p-4">
        <SkeletonLoader className="w-24 h-4" variant="text" />
      </td>
      <td className="p-4">
        <SkeletonLoader className="w-20 h-4" variant="text" />
      </td>
    </tr>
  );
}
